import { createReducer, on } from '@ngrx/store';
import { CreateNewIntegration } from 'src/app/modules/administration/integration-management/actions/integration-management-create-new.actions';
import {
  ActiveComponentChanged,
  GetLanguageSuccess,
  SetActiveTabIndex,
  ValidateSubscriptionFailed,
  ValidateSubscriptionSuccess,
} from '../actions/eliqua.actions';
import { ActiveComponent } from '../models/grid.model';

export interface EliquaState {
  activeComponent: string;
  activeTabIndex: number;
  isSubscriptionActive: boolean;
  enableLockedOverlay: boolean;
  subscriptionEndDate: Date | null;
  language: string;
}

const initialState: EliquaState = {
  activeComponent: '',
  activeTabIndex: 0,
  isSubscriptionActive: true,
  enableLockedOverlay: false,
  subscriptionEndDate: null,
  language: 'en',
};

export const EliquaReducer = createReducer(
  initialState,
  on(ActiveComponentChanged, (state, { activeComponent }) => ({
    ...state,
    activeComponent,
  })),
  on(SetActiveTabIndex, (state, { activeTabIndex }) => ({
    ...state,
    activeTabIndex,
  })),
  on(CreateNewIntegration, (state) => ({
    ...state,
    activeComponent: ActiveComponent.DetailsIntegration,
  })),
  on(ValidateSubscriptionSuccess, (state, { res }) => ({
    ...state,
    isSubscriptionActive: res.payload.data.isSubscriptionActive,
    enableLockedOverlay: !res.payload.data.isSubscriptionActive,
    subscriptionEndDate: res.payload.data.subscriptionEndDate,
  })),
  on(ValidateSubscriptionFailed, (state) => ({
    ...state,
  })),
  on(GetLanguageSuccess, (state, { res }) => ({
    ...state,
    language: res,
  })),
);
